import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import TicketReport from "../User/TicketReport";
import MyTickets from "./MyTickets";
import { DecryptED } from "../../DecryptJS/Decrypt";
import { isGenericAccountName } from "../ReusedComponents/genericAccounts";

// Admin's landing route shows different UI depending on whether the
// visitor has a real staff record at this school:
//  - Real staff member (any committee/type, e.g. Head of School) -> the
//    existing "Admin Dashboard" card view (MyTickets.js).
//  - No matching staff record (e.g. a generic/shared login like
//    "SCHOOL ADMINISTRATOR") -> the Reports/List view, which is already
//    scoped to just their own created tickets for this case.
//
// staff_id is only unique WITHIN a school, not globally — a generic
// login's fixed uid can coincidentally match a real staff member's id at
// some other school (e.g. uid 170 collided with a real "Peon" at one
// school). So a name-based check on the actual logged-in user is used
// as an override: if their real name is a known generic account, they're
// always restricted, regardless of any coincidental staff_id match.
export default function Dashboard() {
  const { sid, uid } = useParams();
  const [loading, setLoading] = useState(true);
  const [isRestrictedAdmin, setIsRestrictedAdmin] = useState(false);

  useEffect(() => {
    var decSid, decUid;
    try { decSid = DecryptED(sid); } catch (e) { decSid = sid; }
    try { decUid = DecryptED(uid); } catch (e) { decUid = ""; }

    var staffPromise = axios.post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
      fun_name: "GetStaffDetails",
      sid: sid,
    }, { timeout: 20000 }).then((res) => {
      var staffList = res.data && Array.isArray(res.data.Staff_Details) ? res.data.Staff_Details : [];
      return staffList.some(function(s) { return String(s.staff_id) === String(decUid); });
    }).catch(() => {
      // Fail open — don't send a real admin to the restricted view over a network hiccup.
      return true;
    });

    var namePromise = axios.post("https://topschool.prisms.in/rest/index.php/user_list.json?", {
      fun_name: "AUserInfo",
      sid: decSid,
      u_id: decUid,
    }, { timeout: 20000 }).then((res) => {
      var d = res.data || {};
      if (d.student && d.student.length > 0) return d.student[0].name;
      if (d.name) return d.name;
      return "";
    }).catch(() => "");

    Promise.all([staffPromise, namePromise]).then(function (results) {
      var hasStaffRecord = results[0];
      var name = results[1];
      setIsRestrictedAdmin(!hasStaffRecord || isGenericAccountName(name));
      setLoading(false);
    });
  }, [sid, uid]);

  if (loading) return null;
  return isRestrictedAdmin ? <TicketReport /> : <MyTickets />;
}
